import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {
  MessageUndoBannerState,
  MessageUndoBannerTypesEnum,
} from '../../../../store/panels/app/banners/bannersState';
import {Banner, BannerTypesEnum} from '../../../common/banners/banner';
import {BannerAction} from '../../../common/banners/bannerAction';
import {BannerIcon} from '../../../common/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../common/banners/bannersContext';
import {BannerText} from '../../../common/banners/bannerText';
import {BannerTimeRemaining} from '../../../common/banners/bannerTimeRemaining';

/*
 * Props.
 */

interface MessageUndoBannerProps {
  state: MessageUndoBannerState;
  onUndoClick: Handler;
  isGuidedDemoActive: boolean;
}

/*
 * Component.
 */

export const MessageUndoBanner: FC<MessageUndoBannerProps> = (props) => {
  const duration = props.state.expiresAt - Date.now();

  if (duration < 0 || props.isGuidedDemoActive) {
    return null;
  }

  return props.state.messageUndoType !== MessageUndoBannerTypesEnum.ONLINE
    ? renderOfflineBanner(props)
    : renderOnlineBanner(props, duration);
};

function renderOnlineBanner(props: MessageUndoBannerProps, duration: number) {
  return (
    <Banner bannerType={BannerTypesEnum.INLINE} priority={BannerPrioritiesEnum.TRANSIENT}>
      <BannerTimeRemaining duration={duration} />
      <BannerIcon iconName="sendFilledSmall" />
      <BannerText>
        <Trans id="banner-undosend-online">Message sent</Trans>
      </BannerText>
      <BannerAction onClick={props.onUndoClick}>
        <Trans id="banner-undo">Undo</Trans>
      </BannerAction>
    </Banner>
  );
}

function renderOfflineBanner(props: MessageUndoBannerProps) {
  return (
    <Banner bannerType={BannerTypesEnum.INLINE} priority={BannerPrioritiesEnum.TRANSIENT}>
      <BannerIcon iconName="outboxFilledSmall" />
      <BannerText>
        <Trans id="banner-undosend-offline">Message moved to Outbox</Trans>
      </BannerText>
      <BannerAction onClick={props.onUndoClick}>
        <Trans id="banner-undo">Undo</Trans>
      </BannerAction>
    </Banner>
  );
}
